<template>
    <div class="search-button ">
        <v-btn 
        v-if="!searchMode"
        @click="searchMode = true" 
        class="search-btn midnightButton buttonBranding_midnight" 
        rounded        
        flat
        :ripple="false"
        >
            <span class="buttonText">Search</span>
            <!-- <v-icon class="icon" right>mdi-magnify</v-icon> -->
            <v-img 
                alt="Search Icon"
            :src="require('@/assets/icons/search-icon.svg')" class="search-icon"/>
        </v-btn>
    </div>
    <div>
        <!-- Deal with the emitter -->
        <search-widget 
            v-if="searchMode"
            @selectedCountry="countrySelected($event)"
        />
    </div>
</template>

<script > 
//TODO : this isn't typescript
export default {
    name: 'SearchButton',
    data() {
        return {
            isMobile: window.innerWidth <= 900,
            searchMode: this.isMobile,
            selectedCountry: null
        };
    },
    mounted() {
        // if it's mobile, set the search mode to true
        if (this.isMobile) {
            this.searchMode = true;
        }
    },
    methods: {
        search() {
            alert('SEARCH!');
        },
        countrySelected(country) {
            this.selectedCountry = country;
            if (!this.isMobile) {
                this.searchMode = false;
            } else {
                this.searchMode = true;
            }
            this.$emit('selectedCountry', country);
        }
    },
    watch:{
        selectedCountry: {
            immediate: true,
            handler(val) {
                if (val) {
                    if (!this.isMobile) {
                        this.searchMode = false;
                    } else {
                        this.searchMode = true;
                    }
                    // emit the selected country to the parent component
                    this.$emit('selectedCountry', val);                    
                }
            }
        }    
    }
}
</script>

<style scoped>

.search-button {
    display: flex;
    justify-content: center;
    align-items: center;
    /* height: 100vh; */
    margin-top: -50px;
    position: absolute;
    top: 50%;
    margin-left: 48px;
    letter-spacing: 0.2px;
}

.search-btn {
    background-color: #333333; /* Adjust this color as needed */
    color: white;
    padding: 25px 24px;
    font-size: 16px;
    display: flex;
    align-items: center;
    border-radius: 50px;
    
    /* Font */

    font-family: 'GCO Sans' !important;
    font-size: 16px;
    font-weight: 100;
    line-height: 20.8px;
    text-align: left;
    letter-spacing: 0.48px;

    text-transform: none;

    cursor: pointer;
}

.icon {
    font-size: 24px;
    margin-left: 10px;
    margin-right: -10px;
}

.search-button .buttonText,
.search-button .icon 
{
    margin-top: 3px !important;
}

.search-icon{
    width: 20px;
    height: 20px;
    margin-left:12px ;
}
</style>
